/**
 * Иконка из набора (ADR-0007, docs/icons.md).
 *
 * Эмодзи выглядят по-разному на iOS, Android и в Telegram Desktop, не
 * подчиняются палитре и в «тёплой бумаге» торчат чужим стилем. Набор
 * нарисован под приложение и живёт в `shared/icons/` — 68 PNG. Знак
 * приложения — не иконка набора, а `BrandMark`.
 *
 * Имя проверяется типом: опечатка становится ошибкой сборки, а не пустой
 * картинкой в проде.
 */

import clsx from 'clsx'

import { type IconName } from '@/shared/ui/icon-names'
import { iconUrl } from '@/shared/ui/icon-url'

export function Icon({
  name,
  size = 24,
  className,
}: {
  name: IconName
  /** Сторона квадрата в пикселях. Иконки разной формы вписываются внутрь. */
  size?: number
  className?: string
}) {
  return (
    <img
      // Иконка всегда декоративна: смысл несёт подпись рядом. Там, где
      // подписи нет, вызывающий код обязан дать кнопке aria-label.
      alt=""
      aria-hidden
      src={iconUrl(name)}
      width={size}
      height={size}
      // Без lazy намеренно: иконка размером 20-30px весит считаные килобайты,
      // а отложенная загрузка дала бы заметное мигание на каждом экране.
      decoding="async"
      draggable={false}
      className={clsx(
        // align-middle обязателен: инлайновая картинка по умолчанию встаёт
        // на базовую линию и проваливается ниже соседнего текста.
        'icon-art inline-block shrink-0 object-contain align-middle select-none',
        className,
      )}
      style={{ width: size, height: size }}
    />
  )
}

export type { IconName }
